
const crop_uischema = {
    view: "main",
    title: "Crop or Commodity Profiles",
    entity: "Crops or Commodities",
    linkBack: {
        name: 'Back to Profiles',
        link: '/dashboard/profiles/'
    },
    button: {
        name: 'New Crops or Commodities',
        style: 'default'
    }
}

export default crop_uischema;